import React, { Component } from 'react';
import { Checkbox } from '@thd-olt-component-react/checkbox';
import PropTypes from 'prop-types';
import './histogram.style.scss';

export class Histogram extends Component {

  getPercentageRating = (totalReviews, countOfStarReviews) => {
    return (parseInt(countOfStarReviews, 10) / parseInt(totalReviews, 10)) * 100;
  };

  histogramBarClick = (ratingValue, count) => {
    const { clickableFilters, onClick, onFilterChange } = this.props;
    if (clickableFilters && count > 0) {
      onFilterChange(ratingValue);
      if (onClick) {
        onClick(ratingValue);
      }
    }
  };

  renderHistogram = (totalReviews, ratingBars) => {
    const {
      clickableFilters,
      filterCheckboxes,
      percentage,
      selectedSentiment,
    } = this.props;
    return (ratingBars || []).map((histogram, index) => (
      <span
        key={histogram.ratingValue}
        className={`reviews-histogram__bar-wrapper ${clickableFilters ? 'no-top-margin' : ''}`}
      >
        <span key={`rating_filter_${histogram.id}`} className="filter-reviews-element">
          { clickableFilters ? (
            <Checkbox
              className="reviews-histogram__bar-wrapper__filter-reviews-element"
              key={filterCheckboxes[index].value}
              id={filterCheckboxes[index].id}
              onChange={
                () => {
                  this.histogramBarClick(parseInt(histogram.ratingValue, 10), histogram.count);
                }
              }
              checked={filterCheckboxes[index].checked}
              value={filterCheckboxes[index].value}
              disabled={!!selectedSentiment || histogram.count < 1}
            />
          )
            : '' }
        </span>
        <span className="reviews-histogram__bar-rating">{histogram.ratingValue}</span>
        <img
          className="reviews-histogram__bar-stars"
          alt="star-icon"
          src="https://assets.homedepot-static.com/images/v1/star-symbol--orange.svg"
        />
        <button
          className="reviews-histogram__bar-graph"
          onClick={() => {
            this.histogramBarClick(parseInt(histogram.ratingValue, 10), histogram.count);
          }}
          type="button"
        >
          <span
            className="reviews-histogram__bar-graph--percent"
            style={{ width: `${this.getPercentageRating(totalReviews, histogram.count)}%` }}
          />
        </button>
        <span className="reviews-histogram__bar-count">
          {percentage
            ? `${parseInt(this.getPercentageRating(totalReviews, histogram.count), 10)}%`
            : `(${histogram.count})`}
        </span>
      </span>
    ));
  };

  render() {
    const {
      filterCheckboxes,
      ratings,
      totalReviews,
    } = this.props;
    const sortedRatings = ratings ? ratings.sort((i, n) => {
      return n.ratingValue - i.ratingValue;
    }) : [];
    return (
      <div className="reviews-histogram">
        {this.renderHistogram(totalReviews, sortedRatings, filterCheckboxes)}
      </div>
    );
  }
}

Histogram.propTypes = {
  clickableFilters: PropTypes.bool,
  filterCheckboxes: PropTypes.arrayOf(PropTypes.shape({
    checked: PropTypes.bool,
    id: PropTypes.string,
    value: PropTypes.string,
  })),
  /** Function when bar is clicked */
  onClick: PropTypes.func,
  onFilterChange: PropTypes.func,
  /** display percentage value instead of count */
  percentage: PropTypes.bool,
  /** Histogram bar label and number of star ratings to calculate % */
  ratings: PropTypes.arrayOf(PropTypes.shape({
    count: PropTypes.number,
    ratingValue: PropTypes.number,
  })),
  selectedSentiment: PropTypes.instanceOf(Object),
  /** Number of total reviews */
  totalReviews: PropTypes.number.isRequired,
};

Histogram.defaultProps = {
  clickableFilters: false,
  filterCheckboxes: null,
  onClick: null,
  onFilterChange: null,
  percentage: false,
  ratings: null,
  selectedSentiment: null,
};
